var React = require('react');

function CircleArrowPrev (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"rotate(-180 20.5 20.5)","fill":"none","fillRule":"evenodd"},[React.createElement("g",{"className":"circle","stroke":"#000","key":0},React.createElement("circle",{"stroke":"","cx":"20","cy":"20","r":"20"})),React.createElement("g",{"className":"line","fill":"#000","key":1},[React.createElement("path",{"d":"M12 18.897h14.654v1.114H12z","key":0}),React.createElement("path",{"d":"M23.463 14.992l4.428 4.462-.774.801-4.428-4.462z","key":1}),React.createElement("path",{"d":"M22.668 23.173l4.407-4.519.816.8-4.364 4.528z","key":2})])]));
}

CircleArrowPrev.defaultProps = {"viewBox":"0 0 42 42"};

module.exports = CircleArrowPrev;

CircleArrowPrev.default = CircleArrowPrev;
